import React, { useState } from "react";
import { Modal, Box, Typography, TextField, Button } from "@mui/material";

const ModalEmail = ({
  open,
  onClose,
  onEnviar,
  titulo = "Enviar correo electrónico",
  descripcion = "Introduce el correo electrónico del destinatario.",
  emailInicial = "",
  textoBotonEnviar = "Enviar",
  textoBotonCancelar = "Cancelar",
  pedirTextoExtra = false,
  labelTextoExtra = "",
  ayudaTextoExtra = "",
  textoExtraInicial = "",
  pedirNombre = false,
  nombreInicial = ""
}) => {
  const [email, setEmail] = useState(emailInicial);
  const [textoExtra, setTextoExtra] = useState(textoExtraInicial);
  const [nombre, setNombre] = useState(nombreInicial);

  // Validación básica de email
  const validarEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email.trim());
  };

  const handleEnviar = () => {
    if (!email.trim()) {
      alert("Debe indicar un correo electrónico.");
      return;
    }

    if (!validarEmail(email)) {
      alert("Debe indicar una dirección de correo válida.");
      return;
    }

    if (pedirNombre) {
      if (!nombre.trim()) {
        alert("Debe indicar el nombre del destinatario.");
        return;
      }
      onEnviar(email.trim(), nombre.trim());
      return;
    }

    if (pedirTextoExtra) {
      const lineas = textoExtra
        .split("\n")
        .map((linea) => linea.trim())
        .filter((linea) => linea.length > 0);

      if (lineas.length === 0) {
        alert("Debe indicar al menos una ruta.");
        return;
      }

      onEnviar(email.trim(), lineas);
      return;
    }

    onEnviar(email.trim());
  };

  const handleClose = () => {
    setEmail(emailInicial);
    setTextoExtra(textoExtraInicial);
    setNombre(nombreInicial);
    onClose();
  };

  // Actualizar el email cuando cambie el emailInicial
  React.useEffect(() => {
    setEmail(emailInicial);
  }, [emailInicial]);

  // Actualizar el texto extra cuando cambie el textoExtraInicial
  React.useEffect(() => {
    setTextoExtra(textoExtraInicial);
  }, [textoExtraInicial]);

  React.useEffect(() => {
    setNombre(nombreInicial);
  }, [nombreInicial]);

  return (
    <Modal open={open} onClose={handleClose}>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          height: "100vh",
          padding: "3%",
        }}
      >
        <Box
          sx={{
            width: { xs: "85%", sm: "80%", md: 400 },
            backgroundColor: "white",
            borderRadius: 1,
            boxShadow: 24,
            padding: 3,
          }}
        >
          <Typography variant="h6" sx={{ marginBottom: 2 }}>
            {titulo}
          </Typography>

          {descripcion && (
            <Typography variant="body2" color="text.secondary" sx={{ marginBottom: 2 }}>
              {descripcion}
            </Typography>
          )}

          {pedirNombre && (
            <TextField
              fullWidth
              label="Nombre del destinatario"
              value={nombre}
              onChange={(e) => setNombre(e.target.value)}
              sx={{ marginBottom: 2 }}
              autoFocus
            />
          )}

          <TextField
            fullWidth
            label="Correo electrónico"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            sx={{ marginBottom: 2 }}
            onKeyPress={(e) => {
              if (!pedirTextoExtra && !pedirNombre && e.key === 'Enter') {
                handleEnviar();
              }
            }}
            autoFocus={!pedirNombre}
          />

          {pedirTextoExtra && (
            <TextField
              fullWidth
              label={labelTextoExtra}
              helperText={ayudaTextoExtra}
              value={textoExtra}
              onChange={(e) => setTextoExtra(e.target.value)}
              multiline
              rows={4}
              sx={{ marginBottom: 2 }}
            />
          )}

          <Box sx={{ display: "flex", justifyContent: "space-between", gap: 2 }}>
            <Button
              variant="outlined"
              fullWidth
              onClick={handleClose}
            >
              {textoBotonCancelar}
            </Button>

            <Button
              variant="contained"
              color="primary"
              fullWidth
              onClick={handleEnviar}
            >
              {textoBotonEnviar}
            </Button>
          </Box>
        </Box>
      </Box>
    </Modal>
  );
};

export default ModalEmail;
